import React from "react";
import { useMediaQuery } from "react-responsive";
import { withStyles } from "@material-ui/styles";

import TabHeader from "./TabHeader";

function SubPageHeader({ classes, currentSubpage, setSubpage, url }) {
  const isMobileLayout = useMediaQuery({
    query: "(max-width: 700px)",
  });

  if (isMobileLayout)
    return (
      <div className={classes.subPageHeaderMobile}>
        <TabHeader
          setSubpage={setSubpage}
          currentSubpage={currentSubpage}
          style={{ boxShadow: "none" }}
          url={url}
          full
        />
      </div>
    );

  return (
    <div className={classes.subpageHeader}>
      <TabHeader
        setSubpage={setSubpage}
        style={{ boxShadow: "none" }}
        currentSubpage={currentSubpage}
        url={url}
      />
    </div>
  );
}

const styles = (theme) => ({
  subpageHeader: {
    width: "100%",
    textAlign: "left",
    fontSize: "25px",
    marginTop: "-9px",
    marginBottom: "20px",
    position: "sticky",
    top: "0px",
    backgroundColor: "white",
    fontWeight: "bold",
    // zIndex: "100000"
  },
  subPageHeaderMobile: {
    width: "100%",
    textAlign: "left",
    fontSize: "25px",
    marginTop: "-9px",
    marginBottom: "20px",
    backgroundColor: "white",
    fontWeight: "bold",
  },
  "@media (max-width: 960px) and (min-width: 701px)": {
    subpageHeader: {
      padding: "21px 0 0",
    },
  },
  "@media (max-width: 960px)": {
    subpageHeader: {
      textAlign: "center",
      marginLeft: 0,
      paddingLeft: 0,
    },
  },
  "@media (max-width: 700px)": {
    subpageHeader: {
      textAlign: "center",
      marginLeft: "0",
      paddingLeft: "0",
      position: "relative",
      marginTop: 0,
    },
  },
});

export default withStyles(styles)(SubPageHeader);
